// extracted by mini-css-extract-plugin
export default {"home":"Contagem_home__8mOfZ","containerA4Horizontal":"Contagem_containerA4Horizontal__YJh4k","listaGalerias":"Contagem_listaGalerias__XKBS9","pulolista":"Contagem_pulolista__BRTHb"};